<div class="pdf-preview-modal">
  <!-- Header -->
  <div class="modal-header">
    <h2 mat-dialog-title class="mb-0">
      <mat-icon class="me-2">description</mat-icon>
    </h2>
    <button 
      mat-icon-button 
      (click)="cerrar()"
      class="btn-close-modal"
      aria-label="Cerrar"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="p-0">
    <!-- Spinner de carga -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p class="mt-3 text-muted">Cargando documento...</p>
    </div>

    <!-- PDF Viewer -->
    <iframe
      [src]="safePdfUrl"
      class="pdf-iframe"
      [class.d-none]="loading"
      (load)="onIframeLoad()"
      frameborder="0"
    ></iframe>
  </mat-dialog-content>

  <!-- Footer -->
  <mat-dialog-actions align="end" class="modal-footer">
    <button
      mat-button
      (click)="cerrar()"
      class="btn-cancelar"
    >
      <mat-icon>close</mat-icon>
      Cerrar
    </button>

    <!-- Botón de validar (solo en modo validación) -->
    <button
      *ngIf="data.modoValidacion && data.estadoActual === 'PROCESADO'"
      mat-raised-button
      (click)="validar()"
      class="btn-validar"
      style="background-color: #4CAF50; color: white;"
    >
      <mat-icon>check_circle</mat-icon>
      Validar Liquidación
    </button>
  </mat-dialog-actions>
</div>
